<template>
	<div class="brick">
		<!-- #3341 JC Barcode List. Item Master 의 바코드 10개(UPC #3~#9 Multiply 포함)를 품목 전체로 보고 Excel 로 받는다. -->
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
				</span>
			</div>
			<div class="left_option" style="padding-top:5px;">
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<input type="text" v-model="keyword" placeholder="Item Code, Name or Barcode" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div style="overflow-x:auto;">
			<table id="barcode_list" class="list_tbl" v-columns-resizable>
				<thead>
					<tr>
						<th style="text-align:center;width:110px;">Item Code</th>
						<th style="text-align:center;min-width:220px;">Name</th>
						<th style="text-align:center;width:60px;">Qty per Carton</th>
						<th style="text-align:center;width:45px;">Unit</th>
						<th style="text-align:center;width:90px;">Packing Unit</th>
						<th style="text-align:center;width:110px;">Customer Ref UPC</th>
						<th style="text-align:center;width:110px;">UPC #1 (CS)</th>
						<th style="text-align:center;width:110px;">UPC #2 (BX)</th>
						<template v-for="n in extra_slots">
							<th :key="'upc_h' + n" style="text-align:center;width:110px;">UPC #{{ n }}</th>
							<th :key="'qty_h' + n" style="text-align:center;width:40px;">x Qty</th>
						</template>
						<th style="text-align:center;width:40px;">Active</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in items" v-bind:key="item.item_id">
						<td>{{ item.item_code }}</td>
						<td class="al_left truncate">{{ item.name }}</td>
						<td style="text-align:right;">{{ item.packing }}</td>
						<td>{{ item.unit_code }}</td>
						<td>{{ item.packing_unit }}</td>
						<td>{{ item.barcode }}</td>
						<td>{{ item.barcode_box }}</td>
						<td>{{ item.barcode_case }}</td>
						<template v-for="n in extra_slots">
							<td :key="'upc' + n">{{ item['barcode' + n] }}</td>
							<td :key="'qty' + n" style="text-align:right;">{{ multiplyQty(item, n) }}</td>
						</template>
						<td style="text-align:center;">{{ item.active_yn }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" class="gray_bt" @click="exportExcel()">Excel</a>
		</div>
	</div>
</template>

<script>
import { apiSelectBarcodeListItems } from '@/api/item/master.js';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import Paging from '@/components/common/Paging';
import { exportDataExcel, isEmpty, objectCopy, objectToFormData } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			page_size: 26,
			page_no: 1,
			list_count: 0,
			active_yn: 'Y',
			// 화면에 반영된 마지막 조회의 조건(Excel 기준). 성공한 조회 전에는 비어 있다.
			saveParam: {},
			request_seq: 0,
			items: [],

			item_classes_string: '',
			item_classes: [],

			keyword: null,

			// UPC #3~#9 은 슬롯별 Multiply Qty 를 가진다(#3145).
			extra_slots: [3, 4, 5, 6, 7, 8, 9],
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		Paging,
		ItemClassSelectMulti,
	},
	methods: {
		selectClasses(input) {
			return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(',');
			else this.item_classes = [];

			this.selectItems();
		},
		reset() {
			this.page_no = 1;
			this.keyword = '';
			this.active_yn = 'Y';

			this.item_classes_string = '';
			this.item_classes = [];
		},
		gotoPage(pageNo) {
			this.selectItems(pageNo);
		},
		// 바코드가 있는데 Multiply Qty 가 비어 있으면 스캔은 1 로 가산한다(Boxing). 바코드가 없으면 빈칸.
		multiplyQty(item, n) {
			if (!item['barcode' + n]) return null;
			const qty = item['barcode' + n + '_qty'];
			return qty == null ? 1 : qty;
		},
		async selectItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			// 요청 시점의 조건을 복사해 두고, 그 응답을 화면에 반영할 때 같은 조건을 Excel 기준으로 저장한다.
			// 조회 중 필터가 바뀌어도 화면과 Excel 이 같은 조건을 쓰고, 늦게 도착한 이전 요청은 무시한다.
			const request_seq = ++this.request_seq;
			const condition = objectCopy({
				active_yn: this.active_yn,
				item_classes: this.item_classes,
				keyword: this.keyword,
			});
			const page_no = this.page_no;

			const { data } = await apiSelectBarcodeListItems(
				objectToFormData(
					Object.assign({}, condition, {
						paging_yn: 'Y',
						page_size: this.page_size,
						page_no: page_no,
						start_index: this.page_size * (page_no - 1),
					}),
				),
			);

			if (request_seq !== this.request_seq) return;

			this.saveParam = condition;
			this.items = data.itemList;
			this.list_count = data.list_count;
			this.$refs.paging.setPage(page_no, this.page_size, this.list_count);
		},
		async exportExcel() {
			// 성공한 조회가 없으면 조건이 없어 서버 기본 페이징(26행)이 적용되므로 막는다(ItemList Sheet 선례).
			if (isEmpty(this.saveParam)) {
				this.$toast.error('Please search first');
				return false;
			}
			// Excel 은 화면에 반영된 조회와 같은 조건의 전체 행을 받는다.
			const { data } = await apiSelectBarcodeListItems(objectToFormData(Object.assign({}, this.saveParam, { paging_yn: 'N' })));

			const rows = data.itemList.map(item => {
				const row = Object.assign({}, item);
				this.extra_slots.forEach(n => {
					row['barcode' + n + '_multiply'] = this.multiplyQty(item, n);
				});
				return row;
			});

			// 바코드는 문자열 셀로 둔다(선행 0·지수 표기 방지). 숫자 열의 NULL 은 빈칸이다.
			const header = [
				{ key: 'item_code', name: 'Item Code', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Name', width: 40, dataType: defaultDataType.string },
				{ key: 'packing', name: 'Qty per Carton', width: 12, dataType: defaultDataType.currency },
				{ key: 'unit_code', name: 'Unit', width: 8, dataType: defaultDataType.string },
				{ key: 'packing_unit', name: 'Packing Unit', width: 15, dataType: defaultDataType.string },
				{ key: 'barcode', name: 'Customer Ref UPC', width: 18, dataType: defaultDataType.string },
				{ key: 'barcode_box', name: 'UPC #1 (CS)', width: 18, dataType: defaultDataType.string },
				{ key: 'barcode_case', name: 'UPC #2 (BX)', width: 18, dataType: defaultDataType.string },
			];
			this.extra_slots.forEach(n => {
				header.push({ key: 'barcode' + n, name: 'UPC #' + n, width: 18, dataType: defaultDataType.string });
				header.push({ key: 'barcode' + n + '_multiply', name: 'UPC #' + n + ' Qty', width: 10, dataType: defaultDataType.currency });
			});
			header.push({ key: 'active_yn', name: 'Active', width: 8, dataType: defaultDataType.string });

			exportDataExcel(rows, header, 'BarcodeList');
		},
	},
	mounted() {
		this.selectItems();
	},
	created() {
		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_barcode_list');
		this.$store.commit('setSubTitle', 'Item -> Barcode List');
	},
};
</script>

<style></style>
